<template>
  <div>
    <va-modal
      v-model="showModal"
      id="leadDetailsModal"
      ref="leadDetailsModal"
      :cancelText="$t('leads.back')"
      size="large"
      :showOkay="false"
      :hideDefaultActions="isMobile"
      @cancel="$emit('cancel')"
      :fixedLayout="true">

      <div slot="header" class="d-flex justify--space-between">
          <span :class="{'col-width': isMobile}">
            <span><b style="font-size:22px; margin-bottom: 1rem; font-weight: bold" class="mr-2"> {{ headerTitle | capitalize }}</b></span>
          </span>

        <span class="close-modal-button" v-if="isMobile">
          <va-button icon="fa fa-times" @click.prevent="$emit('cancel')"></va-button>
        </span>
      </div>

      <!-- Person information -->
      <div class="row">
        <h3>{{$t('evohealth.patient.details_title')}}</h3>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{$t('people_manager.table.name')}}:
            </span>
          {{selectedLead.person ? selectedLead.person.name ? selectedLead.person.name : "N/A" : "N/A"}}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{$t('people_manager.table.phone')}}:
            </span>
          {{ selectedLead.person && selectedLead.person.mobilePhone ? selectedLead.person.mobilePhone : "N/A"}}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{$t('people_manager.table.email')}}:
            </span>
          {{ selectedLead.person && selectedLead.person.email ? selectedLead.person.email : "N/A"}}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{$t('people_manager.table.birthdate')}}:
            </span>
          {{ selectedLead.person && selectedLead.person.birthdate ? moment.utc(selectedLead.person.birthdate).locale('pt').local().format('YYYY-MM-DD') : "N/A"}}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{$t('people_manager.table.gender')}}:
            </span>
          {{ selectedLead.person && selectedLead.person.gender ? $t(`genders.${selectedLead.person.gender}`) : "N/A"}}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{$t('people_manager.tax_nr')}}:
            </span>
          {{ selectedLead.person && selectedLead.person.taxNr ? selectedLead.person.taxNr : "N/A"}}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3" v-if="selectedLead.person && selectedLead.person.healthNr">
            <span class="is-bold">
              {{$t('people_manager.health_nr')}}:
            </span>
          {{ selectedLead.person && selectedLead.person.healthNr ? selectedLead.person.healthNr : "N/A"}}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{$t('people_manager.table.address')}}:
            </span>
          {{ handleAddress() }}
        </div>

        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{$t('people_manager.table.country')}}:
            </span>
          {{ selectedLead.person && selectedLead.person.country ? countries.find(elem => elem.code === selectedLead.person.country.toUpperCase()).name : "N/A" }}
        </div>
      </div>

      <hr class="separator-lead-details">

      <div class="row">
        <h3>{{$t('biosigns.lead_details_title')}}</h3>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{$t('biosigns.columns.entity')}}:
            </span>
          {{selectedLead.entity ? selectedLead.entity.name : "N/A"}}
        </div>

        <div v-for="healthParam in visibleHealthParams" class="col-12 col-md-6 col-6 mb-3">
            <span class="is-bold">
              {{$t(`biosigns.columns.${healthParam.name}`)}}:
            </span>
          {{ extractValue(healthParam) }}
        </div>
      </div>

    </va-modal>
  </div>
</template>

<script>
import moment from 'moment';
import * as countries from 'i18n-iso-countries';
import Vue from 'vue';

export default {
  props: {
    selectedLead: {
      type: Object,
      required: true,
    },
    healthParams: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      showModal: false,
    };
  },
  mounted() {
    this.showModal = true;
  },
  methods: {
    handleAddress: function() {
      let addressStr = ''
      if(this.selectedLead.person) {
        if (this.selectedLead.person && this.selectedLead.person.addressLine) {
          addressStr += this.selectedLead.person.addressLine + " "
        }
        if(this.selectedLead.person.country.toLowerCase() === 'pt') {
          if(this.selectedLead.person.concelho) {
            addressStr += this.selectedLead.person.concelho.name
          }
          if(this.selectedLead.person.concelho && this.selectedLead.person.concelho.distrito) {
            addressStr += ', '+this.selectedLead.person.concelho.distrito.name + ' '
          } else {
            addressStr +=' '
          }
        } else {
          if(this.selectedLead.person.county) {
            addressStr += this.selectedLead.person.county + " "
          }
        }

        if(this.selectedLead.person.postalCode) {
          addressStr += this.selectedLead.person.postalCode + " "
        }
      }
      return addressStr === '' || addressStr === ' ' ? "N/A" : addressStr
    },
    extractValue: function (healthParam) {
      if(this.selectedLead.values === null || this.selectedLead.values.length === 0) {
        return "N/A"
      }
      const leadValue = this.selectedLead.values[0].leadValues.find(val => val.healthParam.id === healthParam.id)
      if(leadValue && leadValue.value !== '' && leadValue.value !== null && leadValue.value !== undefined) {
        let valueText = leadValue.value
        if(healthParam.unit) valueText += ` ${healthParam.unit}`
        return valueText
      }

      return "N/A"
    }
  },
  computed: {
    visibleHealthParams: function() {
      const relevantHealthParamsNames = ['heartRate', 'heartRateVariability', 'systolicBloodPressure', 'diastolicBloodPressure', 'respiratoryRate', 'oxygenSaturation', 'stressIndex',
        'metabolism', 'activity', 'relaxation', 'sleep', 'health', 'equilibrium']


      return this.healthParams.filter(param => relevantHealthParamsNames.includes(param.name))
    },
    isMobile: function() {
      return window.matchMedia(`(max-width: 767px)`).matches || window.matchMedia(`(max-height: 400px)`).matches;
    },
    headerTitle: function () {
      let header = ''
      header += `${this.selectedLead.person ? this.selectedLead.person.name ? this.selectedLead.person.name : "N/A" : "N/A"} - ${this.$options.filters.localTime(this.selectedLead.createdAt, 'YYYY-MM-DD HH:mm')}`
      return header
    },
    countries: function () {
      for (let code of this.$store.state.countries.allowed) {
        if (code.toLowerCase() === "gb") {
          code = "en"
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${code.toLowerCase()}.json`))
      }
      let tempCountries = countries.getNames(Vue.i18n.locale().toLowerCase() === 'gb' ? 'en' : Vue.i18n.locale().toLowerCase())
      let countriesList = []
      for(const key in tempCountries) {
        countriesList.push({
          name: tempCountries[key],
          code: key
        })
      }
      return countriesList
    },
  },
};
</script>

<style scoped lang="scss">

</style>
